import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {
  constructor(
    private responsive: BreakpointObserver,
  ) { }
  small$:Observable<boolean> = this.responsive.observe([Breakpoints.Small, Breakpoints.XSmall]).pipe(map((result:BreakpointState) => result.matches))
  desktop$:Observable<boolean> = this.responsive.observe([Breakpoints.Tablet,Breakpoints.TabletLandscape, Breakpoints.TabletPortrait, Breakpoints.Web]).pipe(map((result:BreakpointState) => result.matches))
  largeDesktop$:Observable<boolean> = this.responsive.observe([Breakpoints.Large, Breakpoints.XLarge]).pipe(map((result:BreakpointState) => result.matches))
}
